<div *ngIf="authService.isAuthenticated">
  <!-- <p>
    Welcome {{ identityClaims?.given_name }} {{ identityClaims?.family_name }}
  </p>
  <p>Email : {{ identityClaims?.email }}</p>
  <p>Token : {{ token }}</p>
  <button (click)="logout()">Logout</button> -->
  <p>Loading...</p>
</div>
